export default __webpack_public_path__ + "static/media/subscribers.e1815b1c.svg";